export default {
  Success: "تمت العملية بنجاح",
  Login: "تسجيل دخول",
  "Sign up": "قم بالتسجيل",
  "Serial number": "الرقم التسلسلي",
  Serial: "الرقم التسلسلي",
  Password: "كلمة المرور",
  "In case you lost your HIRO's message please click here ":
    "في حالة أنك فقدت الرسالة يرجى الضغط هنا",
  "reset password": "إعادة تعيين كلمة المرور",
  "Add sub account": "إضافة حساب فرعي",
  "Personal Info": "المعلومات الشخصية",
  "First name": "الاسم الأول",
  "Last name": "الكنية",
  "Father name": "اسم الأب",
  "Mother name": "اسم الأم",
  "Mobile number": "رقم الموبايل",
  "ID type": "نوع الهوية",
  "ID number": { 1: "رقم جواز السفر", 2: "الرقم الوطني" },
  "Residence Info": "معلومات السكن",
  Gender: "الجنس",
  Nationality: "الجنسية",
  Year: "السنة",
  Month: "الشهر",
  Day: "اليوم",
  "Marital status": "الحالة الاجتماعية",
  Area: "المنطقة",
  Address: "العنوان",
  "ER Profile": "حساب الطوارئ",
  "Kind of relationship": "نوع العلاقة",
  "Sub account": "حساب فرعي",
  "Full name": "الاسم الكامل",
  Previous: "السابق",
  Next: "التالي",
  Done: "تم",
  "Select your": "اختر ",
  country: "الدولة",
  "Choose your country": "حدد دولتك",
  Doctors: "أطباء",
  Labs: "المخابر",
  All: "الكل",
  "Enter keyword to search": "بحث..",
  Me: "حسابي",
  Records: "سجلاتي",
  "My Records": "سجلاتي الصحية",
  Map: "الموقع",
  Collaborators: "المساهمون",
  Wallet: "محفظتي",
  "Health Wallet": "محفظتي الطبية",
  Menu: "القائمة",
  "My profile": "حسابي",
  "My info": "معلوماتي",
  Edit: "تعديل",
  Save: "حفظ",
  Consultations: "المعاينات",
  Vaccines: "اللقاحات",
  Date: "التاريخ",
  "Doctor name": "اسم الطبيب",
  "More information": "معلومات إضافية",
  "Lab name": "اسم المخبر",
  "Test name": "اسم التحليل",
  Complaint: "الشكوى",
  "Primary diagnosis": "التشخيص الأولي",
  Attachments: "المرفقات",
  Report: "التقرير",
  "Lab tests": "التحاليل",
  Radiology: "الأشعة",
  Medications: "الأدوية",
  Note: "ملاحظات",
  Age: "العمر",
  Height: "الطول",
  Weight: "الوزن",
  Public: "عام",
  Private: "خاص",
  "Create wallet": "إضافة",
  Description: "تفاصيل",
  Cancel: "إلغاء",
  Submit: "موافق",
  POS: "نقاط الدفع",
  Confirm: "التأكيد",
  "Do you agree to authorize selected parties to access your health data when needed?":
    "هل توافق على منح التفويض للجهات المختارة بالاطلاع على بياناتك الصحية عند الحاجة لذلك؟ ",
  "Yes , I agree": "نعم، انا موافق",
  No: "لا",
  "Thank you": "شكرا لك",
  "Contact us": "تواصل معنا",
  "About us": "عن التطبيق",
  "Access Control": "التحكم بالوصول",
  "Who can see my health information?":
    "من يستطيع الاطلاع  على معلوماتي الصحية؟",
  Logout: "تسجيل خروج",
  "Only me": "فقط انا",
  "Specific Doctor(s)": "أطباء محددون",
  "All Doctors": "جميع الاطباء",
  "Choose Doctors": "اختر طبيباُ",
  "Enter your message": "اكتب رسالتك",
  Guide: "دليل الاستخدام",
  "Change language": "تغيير اللغة",
  "Change country": "تغيير الدولة",
  "Add patient": "إضافة مريض",
  "No results": "لا يوجد نتائج للعرض",
  "Select a specialization": "اختر الاختصاص",

  "A message has been sent to :number with your serial number and password":
    "تم ارسال رسالة بالرقم المتسلسل وكلمة المرور الى :number",
  "The First Full-on Health Record Generating System":
    "النظام الأول لخلق سجل صحي الكتروني كامل تلقائيا",
  "You are offline": "أنت غير متصل",
  Reload: "تحديث",
  "Privacy policy": "سياسة الخصوصية",
  "Enter your serial number that you received from HIRO (10 digits)":
    "أدخل كلمة السر التي أُرسلت لك من HIRO (مكونة من 4 خانات)",
  "Enter your password that you received in the same message from HIRO (4 digits)":
    "أدخل كلمة السر التي أُرسلت لك من HIRO (مكونة من 4 خانات)",
  "Are you a Hiro subscriber and have an electronic health record?":
    "هل أنت مشترك هيرو وتملك سجل صحي إلكتروني؟",
  "Enter the serial number and password to log in.":
    "أدخل الرقم التسلسلي وكلمة السر لتسجيل الدخول.",
  "You are not subscribed and want to create an EHR?":
    "أنت غير مشترك وترغب في إنشاء سجل صحي إلكتروني؟",
  "To send you your EHR's serial number and password":
    "ليتم تزويدك برسالة تحتوي على رقم سجلك الصحي وكلمة السر الخاصة به",
  "To avoid duplication of EHR'S with another patient":
    "لتجنب تشابه وتكرار السجلات الصحية مع مريضٍ آخر.",
  "Allows you to create an account for the people you are responsible for (children, parents)":
    "يتيح لك إنشاء حساب لأحد الأشخاص المسؤول عنهم (أب، أم، طفل)",
  "Please enter your personal info as an account responsible":
    "يرجى إدخال معلوماتك الشخصية كمسؤول عن المريض.",
  "Please enter the personal info of someone of a close person to contact in case of emergency":
    "يرجى إدخال المعلومات الشخصية لأحد الأشخاص المقربين منك، ليتم التواصل معه في حالات الطوارئ.",
  "Please enter your mobile number and date of birth as it is written on your ID and you will receive the message.":
    "يرجى إدخال رقم الموبايل وتاريخ الميلاد كما في الهوية، وستصلكم رسالة تحتوي على رقم السجل الصحي وكلمة السر.",
};
